import React from "react";

export default function DrawerException() {
  return <div>Drawer Exception</div>;
}
